export default function Ball(x, y, r = 40) {
  return {
    name: "ball",
    pos: { x, y },
    radius: r,
    type: "circle",
    root: true,
  };
}
